export const ENVIAR_NOVA_MENSAGEM_ATENDENTE_NO_SCROLL_TOP =
  'enviarNovaMensagemAtendenteNoScrollTop';
